import type { ReactNode } from 'react';
import type { ToastIntent } from '@fluentui/react-components';

export type ToastShowOptions = {
  timeoutMs?: number | null;
  intent?: ToastIntent;
};

type DispatchFn = (
  content: ReactNode,
  options: { timeoutMs: number | null; intent?: ToastIntent }
) => void;

let dispatch: DispatchFn | null = null;

export const bindToastDispatch = (fn: DispatchFn) => {
  dispatch = fn;
  return () => {
    if (dispatch === fn) dispatch = null;
  };
};

export const toast = {
  show: (content: ReactNode, options?: ToastShowOptions) => {
    dispatch?.(content, {
      timeoutMs: options?.timeoutMs === undefined ? 3000 : options.timeoutMs,
      intent: options?.intent,
    });
  },
};
